module.exports = __webpack_public_path__ + "img/canada.2aa836db.svg";